import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import LiveIcon from "../../../assets/images/AdminLiveProfile/live 1.png";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LivChatStarNav from "../../../Layouts/Partial/LivChatStarNav";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LiveChatContent = () => {
  const params = useParams();
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [img, setImg] = useState("");
  const [buffer, setBuffer] = useState(true);

  const imageSuffle = (type) => {
    if (type === "pending") setImg(LiveIcon);
  };

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/live-chat/approved`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });

    imageSuffle(params.type);
  }, [params.type]);

  return (
    <>
      <div className="AS">
        <LivChatStarNav />
        {buffer ? (
          <LoaderPost />
        ) : (
          <>
            {event_data === 0 ? (
              <>
                <div className="card card-bg head-line mt-4 mb-2">
                  <h5 className="text-light text-center">
                    <img src={LiveIcon} alt="" className="img-fluid mx-2 p-2" />{" "}
                    Live Chat profile
                  </h5>
                </div>
                <div className=" text-center bg-dark p-2 mt-2">
                  <i
                    style={{ color: "#ffc107" }}
                    className="fas fa-box-open fa-4x my-2"
                  ></i>
                  <h2 className="fw-bold text-light">No Data here</h2>
                  <h5 className="text-light my-3">
                    Create Default LiveChat Profile Now!
                  </h5>
                  <p className=" my-2 text-muted">
                    {/* Lorem ipsum dolor sit, amet consectetur adipisicing elit. */}
                  </p>
                  <Link to="/superstar/live-chat/create">
                    <button className=" btn bottom-rightPost text-dark btn-warning my-5 px-5 fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd">Create Now</span>
                    </button>
                  </Link>
                </div>
              </>
            ) : (
              <>
                <div className="card card-bg head-line mb-2">
                  <div className="text-light d-flex justify-content-center p-2">
                    <div className="faTrophy">
                      <i className="fas fa-trophy"></i>
                    </div>
                    <h4 className="mx-3 text-white p-2">
                      <span className="livechat-card-small">All Live Chat</span>
                    </h4>
                  </div>
                </div>
                <AllModuleData
                  data={event_data}
                  urlLink={`/superstar/live-chat/details`}
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default LiveChatContent;
